module.exports = "/images/seller-welcome-1.jpg?cc16edbba9a87473e7242aa1cd36a1ae";